"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function toText(editorState) {
  return editorState.list.value.filter(function (ch) {
    return ch.type !== 'block-end';
  }).map(function (ch) {
    if (ch.type == null) {
      var text = ch;
      return text.char;
    } else {
      return '\n';
    }
  }).join('');
}

exports.default = toText;